import { Component, input } from '@angular/core';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

import { DocumentPreviewModel } from './document-preview.model';

@Component({
  selector: 'sb-document-preview',
  standalone: true,
  imports: [NgxDocViewerModule],
  templateUrl: './document-preview.component.html',
})
export class DocumentPreviewComponent {
  public documentData = input.required<DocumentPreviewModel>();
}
